import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {AddressService} from '../../core/services/address.service';
import {LegalEntity} from '../model/legal-entity.model';
import {INewAddress} from '../model/interface/new-address.interface';
import {Observable} from 'rxjs';
import {EventBusService} from '../../core/services/event-bus.service';
import {DictionaryPosition} from '../model/dictionary.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Address} from '../model/address.model';

@Component({
  selector: 'app-add-customer-address',
  templateUrl: './add-customer-address.component.html',
  styleUrls: ['./add-customer-address.component.css']
})
export class AddCustomerAddressComponent implements OnInit {
  customer: LegalEntity;
  addressForm: FormControl;

  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<AddCustomerAddressComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private eventBusService: EventBusService,
              private addressService: AddressService) {
    this.applyData(data);
  }

  ngOnInit(): void {
    this.addressForm = this.formBuilder.control(null);
  }

  createAddress() {
    const payload = this.createCreateAddressPayload();
    const request = this.createCreateAddressRequest(payload);
    return this.handleCreateAddressRequest(request);
  }

  private createCreateAddressPayload(): INewAddress {
    const formValue = this.addressForm.value;
    return {
      city: formValue.city,
      estateNumber: formValue.estateNumber,
      localNumber: formValue.localNumber,
      postalCode: formValue.postalCode,
      street: formValue.street,
      typeId: formValue.typeId,
      county: 'Polska'
    };
  }

  private createCreateAddressRequest(payload: INewAddress) {
    return this.addressService.createAddress(this.customer.id, payload);
  }

  private handleCreateAddressRequest(request: Observable<any>) {
    return request.subscribe((address: Address) => {
      this.eventBusService.display(DictionaryPosition.OK);
      this.customer.addresses.data.push(address)
      this.dialogRef.close();
    });
  }

  private applyData(data) {
    this.customer = data;
  }
}
